<template>
    <div class="global-tag-area">
        <div v-for="(tag, index) in tags"
            :key="index">
            <div
                v-on:click="selectTag"
                v-bind:class="{ 'global-tag-active': tag.active }"
                :data-index="index"
                class="global-tag">
                {{ tag.name }}
            </div>
        </div>
    </div>
</template>

<script>
 export default {
     name: "GlobalTag",
     data() {
         return {
             tags: [
                 {
                     name: "名字不合规",
                     active: false
                 },
                 {
                     name: "包装类型不对",
                     active: false
                 }
             ]
         }
     },
     methods: {
         selectTag(e) {
             var tags = this.tags
             tags[e.target.dataset.index].active = !tags[e.target.dataset.index].active
             this.tags = tags
         },

         reset() {
             var tags = this.tags
             for (var i = 0; i < tags.length; i++) {
                 tags[i].active = false
             }

             this.tags = tags
         }
     }
 }
</script>

<style scoped>
 .global-tag-area {
     margin-top: 40px;
     margin-bottom: 40px;
 }

 .global-tag {
     background-color: #E5E5E5;
     border-radius: 20px;
     padding-left: 10px;
     padding-right: 10px;
     padding-top: 3px;
     padding-bottom: 3px;
     margin-top: 10px;
     margin-bottom: 10px;
     user-select: none;
 }

 .global-tag-active {
     background-color: #D80E3B;
     color: #FFF;
 }
</style>
